import LayerGroup from 'ol/layer/Group.js';
import TileLayer from 'ol/layer/Tile.js';
import OSM from 'ol/source/OSM.js';
import type BaseLayer from 'ol/layer/Base.js';
import type { createVectorBasemapLayer } from './vector-basemap-layer.js';
import type { applyStyle, applyBackground } from 'ol-mapbox-style';

export interface PublicBasemapDefinition { styleUrl?: string; background: string; attributionHtml: string; attributionText: string }
export interface PublicBasemapModules { applyStyle: typeof applyStyle; applyBackground: typeof applyBackground; createVectorBasemapLayer: typeof createVectorBasemapLayer }

export function createPublicRasterBasemap(attribution: string): TileLayer {
  return new TileLayer({ cacheSize: 512, source: new OSM({ crossOrigin: 'anonymous', attributions: attribution }) });
}

export function createPublicVectorBasemap(definition: PublicBasemapDefinition, fallback: PublicBasemapDefinition, load: () => Promise<PublicBasemapModules>, dispose: (layers: BaseLayer[]) => () => void) {
  const layer = new LayerGroup();
  const ready = load().then(({ applyStyle, applyBackground, createVectorBasemapLayer }) => {
    const vectorLayer = createVectorBasemapLayer();
    layer.getLayers().push(vectorLayer);
    return Promise.all([applyStyle(vectorLayer, definition.styleUrl!, 'openmaptiles'), applyBackground(vectorLayer, definition.styleUrl!)]);
  }).then(() => undefined).catch(() => {
    console.warn('OpenFreeMap Positron failed to load. Using OpenStreetMap instead.');
    const finish = dispose(layer.getLayers().getArray());
    layer.getLayers().clear();
    finish();
    layer.getLayers().push(createPublicRasterBasemap(fallback.attributionHtml));
  });
  return { layer, ready };
}
